import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 *
 * */
@Component({
  selector: 'campfire-image-details-modal',
  templateUrl: './image-details.modal.component.html',
  styleUrls: ['./image-details.modal.component.scss']
})
export class ImageDetailsModalComponent {
  @Input() image: any;

  constructor(private modal: NgbActiveModal) {

  }

  close(): void {
    this.modal.close();
  }
}

